import { render, staticRenderFns } from "./penggunaan-informasi.vue?vue&type=template&id=5ec3c11a"
import script from "./penggunaan-informasi.vue?vue&type=script&lang=js"
export * from "./penggunaan-informasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports